<script setup lang="ts">
const model = defineModel<boolean>({ default: false });
/** `hint` goes under the label in smaller text: what turning it on does. */
defineProps<{ label: string; hint?: string; disabled?: boolean }>();
</script>
<template>
  <div class="switch-row">
    <span v-if="hint" class="switch-text"
      ><span>{{ label }}</span
      ><small class="muted">{{ hint }}</small></span
    ><span v-else>{{ label }}</span
    ><button
      class="wa-switch"
      type="button"
      role="switch"
      :aria-label="label"
      :aria-checked="model"
      :disabled="disabled"
      @click="model = !model"
    />
  </div>
</template>
